import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInvoices } from "../repositories/storeRep";

const initialState = {
  data: [],
  loading: false,
  error: null,
};
export const getInvoicesData = createAsyncThunk("invoices", async (thunkAPI) => {
  const response = await getInvoices();
  return response;
});

export const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  extraReducers: {
    [getInvoicesData.pending]: (state) => {
      state.loading = true;
    },
    [getInvoicesData.fulfilled]: (state, action) => {
      state.loading = false;
      const data = [
        ["#14", "hussein","sent" ,"01/03/1996","$746.5"],
        ["#44" , "heba","void" , "04/03/1999","$906.5"],
        ["#555", "john","paid" , "01/03/2020","$76.5"],
        ["#444", "bruno","paid" , "01/08/2022","$7.5"],
        ["#334" , "ali","sent" , "01/01/2021","$200.5"],
        ["#455", "adam","paid" , "01/03/1996","$746.20"],
        ["#555", "maya","paid" , "01/03/1996","$800.5"],
      ];
     
      state.data = data;
      //state.data= Object.values(action.payload.data);
    },
    [getInvoicesData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default invoicesSlice.reducer;
